import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  width?: number | string;
  height?: number | string;
  isActive?: boolean;
  color?: string;
}

const PapersIcon: React.FC<IconProps> = ({
  width = 16,
  height = 17,
  isActive = false,
  color = '#333333',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.8333 0.166626C14.2754 0.166626 14.6993 0.342221 15.0118 0.654781C15.3244 0.967342 15.5 1.39127 15.5 1.83329V11.8333C15.5 12.2753 15.3244 12.6992 15.0118 13.0118C14.6993 13.3244 14.2754 13.5 13.8333 13.5H12.1667V15.1666C12.1667 15.6087 11.9911 16.0326 11.6785 16.3451C11.3659 16.6577 10.942 16.8333 10.5 16.8333H2.16667C1.72464 16.8333 1.30072 16.6577 0.988155 16.3451C0.675595 16.0326 0.5 15.6087 0.5 15.1666V5.16663C0.5 4.7246 0.675595 4.30068 0.988155 3.98811C1.30072 3.67555 1.72464 3.49996 2.16667 3.49996H3.83333V1.83329C3.83333 1.39127 4.00893 0.967342 4.32149 0.654781C4.63405 0.342221 5.05797 0.166626 5.5 0.166626H13.8333ZM10.5 5.16663H2.16667V15.1666H10.5V5.16663ZM6.33333 11C6.55435 11 6.76631 11.0878 6.92259 11.244C7.07887 11.4003 7.16667 11.6123 7.16667 11.8333C7.16667 12.0543 7.07887 12.2663 6.92259 12.4225C6.76631 12.5788 6.55435 12.6666 6.33333 12.6666H4.66667C4.44565 12.6666 4.23369 12.5788 4.07741 12.4225C3.92113 12.2663 3.83333 12.0543 3.83333 11.8333C3.83333 11.6123 3.92113 11.4003 4.07741 11.244C4.23369 11.0878 4.44565 11 4.66667 11H6.33333ZM13.8333 1.83329H5.5V3.49996H10.5C10.942 3.49996 11.3659 3.67555 11.6785 3.98811C11.9911 4.30068 12.1667 4.7246 12.1667 5.16663V11.8333H13.8333V1.83329ZM8 7.66663C8.2124 7.66686 8.41669 7.74819 8.57114 7.894C8.72559 8.03981 8.81853 8.23909 8.83098 8.45112C8.84342 8.66316 8.77444 8.87194 8.63811 9.03482C8.50179 9.1977 8.30841 9.30237 8.0975 9.32746L8 9.33329H4.66667C4.45427 9.33306 4.24997 9.25173 4.09553 9.10592C3.94108 8.96011 3.84814 8.76083 3.83569 8.5488C3.82324 8.33676 3.89223 8.12798 4.02855 7.9651C4.16488 7.80222 4.35825 7.69755 4.56917 7.67246L4.66667 7.66663H8Z"
      fill={isActive ? 'url(#gradient)' : color}
    />
    {isActive && (
      <defs>
        <linearGradient
          id="gradient"
          x1="0.5"
          y1="8.49996"
          x2="15.3671"
          y2="7.0943"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD84BE" />
          <stop offset="0.5" stopColor="#FB7BDB" />
          <stop offset="1" stopColor="#BF78F2" />
        </linearGradient>
      </defs>
    )}
  </svg>
);

export default PapersIcon;
